const CONFIG = {
    serverUrl: "https://peaceful-escarpment-33332.herokuapp.com/api",
    env: "DEMO" // should either be "DEMO" or "PROD"
}

export default CONFIG;